import styled from "styled-components";

export const PatientFirm = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .title {
      font-family: "Nunito Sans Light";
      font-size: 25px;
      color: #3e3e5b;
    }
    .subtitle {
      font-size: 19px;
      color: #1168ff;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .firm-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .firm-pad {
      position: relative;
      flex: 1;
      margin: 20px;
      background-color: #eeeef7;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      border-radius: 27px;
      &__clear-button {
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 300;
      }
      .firm-pad__canvas {
        height: 100%;
        width: 100%;
        z-index: 200;
        &-pad {
          height: 100%;
          width: 100%;
        }
      }
      .firm-pad__label {
        z-index: 100;
        padding: 10px 0;
        font-size: 19px;
        color: #707582;
        border-top: 1px solid #707582;
        box-sizing: border-box;
        text-align: center;
        position: absolute;
        bottom: 0;
        width: 90%;
        margin-bottom: 40px;
      }
    }
  }
  .buttons {
    display: flex;
    background: #e9e9f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 20px;
    margin-top: auto;
    box-sizing: border-box;
    .cancel-button {
      margin-right: 20px;
    }
    .continue-button {
      flex: 1;
    }
  }
`;
